module.exports = __webpack_public_path__ + "img/code4.091e18b6.png";